
























































































import Vue from 'vue';
import VeLine from 'v-charts/lib/line.common';
import VeBar from 'v-charts/lib/bar.common';
import moment from 'moment';

const TrendType = {
  Read: 1,
  Share: 2,
  Fav: 3,
};

export default Vue.extend({
  components: {
    VeLine,
    VeBar,
  },
  props: {
    newsData: {
      type: Object,
      default: null,
    },
    task: {
      type: Object,
    },
  },
  data() {
    return {
      TrendType,
      trendType: TrendType.Read,
      loading: false,
      legend: {
        show: false,
      },
      listData: [],
      chartTheme: {
        valueAxis: {
          splitLine: {
            lineStyle: {
              color: '#f1f1f1',
            },
          },
        },
      },
      chartSettings: {
        stack: { 'date': ['count']},
        area: true,
        labelMap: {
          count: '人数',
        },
      },
      chartSettingsV: {
        metrics: ['count'],
        labelMap: {
          count: '人数',
        },
        // dataOrder: {
        //   label: 'count',
        //   order: 'desc',
        // },
        label: {
          show: true,
          textStyle: {
            fontSize: '12',
            color: '#000',
          },
          position: 'right',
        },
      },
      grid: [{
        y: 30,
        y2: 30,
      }],
      gridV: [{
        y: 10,
        y2: 30,
        x: 0,
        x2: 60,
      }],
      overviewData: {
        columns: ['cat', 'count'],
        rows: [],
      },
      chartData: {
        columns: ['date', 'count'],
        rows: [],
      },
      chartExtend: {
        series: {
          symbolSize: 6,
          itemStyle: {
            normal: {
              color: '#00A287',
              lineStyle: {
                color: '#00A287',
              },
            },
          },
          areaStyle: {
            normal: {
              color: '#D9F0ED',
            },
          },
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#f1f1f1',
            },
          },
          axisLabel: {
            color: '#666',
          },
          nameTextStyle: {
            color: '#666',
          },
          boundaryGap: false,
        },
        yAxis: {
          axisLine: {show: false}, 
          // minInterval: 100,
          // max: function(value: any) {
          //   return value.max + 100;
          // }
        },
      },
      chartExtendV: {
        tooltip: {
          show: false,
        },
        series: {
          barWidth: 12,
          barGap: 30,
        },
        xAxis: {
          show : false,
        },
        yAxis: {
          // show : false,
          splitLine: {show: false},
          axisLine: {show: false}, 
          axisTick: {show: false},
        },
      },
      colors: ['#D9F0ED'],
      colorsV: ['#00A287'],
    };
  },
  watch: {
    trendType() {
      this.chartData.rows = [];
      this.getChartDataL();
    },
  },
  computed: {
    dates(): Array<string> {
      const arr = Array.from(Array(7).keys());
      return arr.map(i => moment(this.task.scheduleAt).add(i, 'days').format('YYYY-MM-DD'));
    },
  },
  methods: {
    getChartDataL() {
      if (this.newsData && this.newsData.data) {
        const data = this.newsData.data;
        if (this.trendType === TrendType.Read) {
          this.dates.map((d: any) => this.chartData.rows.push({date: d.substring(5, d.length), count: data.find((r: any) => r.date === d) ? data.find((r: any) => r.date === d).pageReadUser : 0}));
        }
        if (this.trendType === TrendType.Share) {
          this.dates.map((d: any) => this.chartData.rows.push({date: d.substring(5, d.length), count: data.find((r: any) => r.date === d) ? data.find((r: any) => r.date === d).shareUser : 0}));
        }
        if (this.trendType === TrendType.Fav) {
          this.dates.map((d: any) => this.chartData.rows.push({date: d.substring(5, d.length), count: data.find((r: any) => r.date === d) ? data.find((r: any) => r.date === d).addToFavUser : 0}));
        }
      }
    },
    getListData() {
      if (this.newsData && this.newsData.data) {
        const data = this.newsData.data;
        this.dates.map((d: any) => this.listData.push({date: d, data: data.find((r: any) => r.date === d) ? data.find((r: any) => r.date === d) : null}));
      }
    },
    getOverviewData() {
      const data = this.newsData.data;
      this.overviewData.rows.push({cat: '收藏人数', count: data.map((d: any) => d.addToFavUser).reduce((a: number, b: number) => a + b, 0)});
      this.overviewData.rows.push({cat: '分享人数', count: data.map((d: any) => d.shareUser).reduce((a: number, b: number) => a + b, 0)});
      this.overviewData.rows.push({cat: '阅读人数', count: data.map((d: any) => d.pageReadUser).reduce((a: number, b: number) => a + b, 0)});
      this.overviewData.rows.push({cat: '送达人数', count: this.task.taskOutput && this.task.taskOutput.MassStat ? this.task.taskOutput.MassStat.sent : 0});
    },
  },
  mounted() {
    this.getChartDataL();
    this.getListData();
    this.getOverviewData();
  },
});

